/*
 * ClearVero storefront copy deterrent. Delegated handlers cover dynamically rendered sections.
 * Editable fields keep native copy, cut, context menus, and keyboard behavior.
 * Shopify design mode does not load this asset; this guard also protects preview tooling.
 * Rollback: remove this asset and its two includes from layout/theme.liquid.
 */
(() => {
  'use strict';

  if (window.Shopify?.designMode || document.documentElement.classList.contains('shopify-design-mode')) return;

  const editableSelector = [
    'input',
    'textarea',
    'select',
    '[contenteditable=""]',
    '[contenteditable="true"]',
    '[contenteditable="plaintext-only"]',
    '[role="textbox"]',
    '[role="searchbox"]'
  ].join(',');

  const isEditable = (event) => {
    for (const node of event.composedPath()) {
      if (node instanceof Element && (node.matches(editableSelector) || node.closest(editableSelector))) {
        return true;
      }
    }

    // Some browsers dispatch a keyboard clipboard event on the document.
    if (event.target === document || event.target === document.body) {
      const focused = document.activeElement;
      return focused instanceof Element && (focused.matches(editableSelector) || focused.closest(editableSelector));
    }

    return false;
  };

  const blockCopy = (event) => {
    if (!isEditable(event)) event.preventDefault();
  };

  document.addEventListener('copy', blockCopy, true);
  document.addEventListener('cut', blockCopy, true);

  document.addEventListener('keydown', (event) => {
    if (
      (event.metaKey || event.ctrlKey) &&
      !event.altKey &&
      !event.shiftKey &&
      (event.key.toLowerCase() === 'c' || event.key.toLowerCase() === 'x') &&
      !isEditable(event)
    ) {
      event.preventDefault();
    }
  }, true);

  document.addEventListener('contextmenu', (event) => {
    if (!isEditable(event)) event.preventDefault();
  }, true);

  document.addEventListener('dragstart', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const image = target.closest('img');
    const imageLink = target.closest('a')?.querySelector('img');
    if (image || imageLink) event.preventDefault();
  }, true);
})();
